import { AsyncExternalLink } from '../types/AsyncExternalLink';
import { Link } from '../types/Link';

export const isAsyncExternalLink = (link: Link): link is AsyncExternalLink => {
  return link.kind === 'async-external';
};
